import { connect } from 'react-redux';

import actions from '../../../actions';
import Align from '../../../components/probing/operations/Align';

export default connect(
  (state, ownProps) => ({
  }),
  (dispatch, ownProps) => ({
    onUpdate: (args) => {
      dispatch(actions.machineState.kinematicsMode.setFiveAxis());
      dispatch(actions.machineState.motion.setPosition(args));
    }
  })
)(Align);
